import { msSessionStorage } from '@common/utils/cache';
import { deepProxy } from '@common/utils/proxy';

// proxy劫持表格变化
export const proxyTable = (table, title) => {
  const tableHandler = {
    set(target, key, value, receiver) {
      // 异步下沉到缓存中
      if (typeof target[key] !== 'function') {
        Promise.resolve().then(() => msSessionStorage.set(title, table));
      }
      return Reflect.set(target, key, value, receiver);
    },
  };

  // 深度劫持
  // 每次发生变化则将数据由内存下沉至缓存
  return deepProxy(table, tableHandler);
};
